import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { api, inr } from "@/lib/api";

const MEDAL = ["text-[#D4A017]", "text-[#8C8498]", "text-[#B87333]"];

export default function ReferralLeaderboard() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/referrals").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <section className="paper mt-10 rounded-lg p-5 sm:p-6" data-testid="referral-leaderboard">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#8C8498]"><Trophy className="h-4 w-4 text-[#D4A017]" />Top referrers</p>
          <h2 className="mt-1 font-serif text-2xl">Customers bringing friends</h2>
        </div>
        <Link to="/admin/promos" data-testid="leaderboard-bonus-link" className="btn-ghost !py-2 !px-3 !text-xs">Create a bonus code →</Link>
      </div>
      {rows.length === 0 ? (
        <p className="mt-4 text-sm text-[#8C8498]" data-testid="leaderboard-empty">No referrals yet — the first friend order will show up here.</p>
      ) : (
        <ol className="mt-5 divide-y divide-[#E8E2D9]" data-testid="leaderboard-list">
          {rows.map((r, i) => (
            <li key={r.user_id} className="flex items-center gap-4 py-3 text-sm" data-testid={`leaderboard-row-${i + 1}`}>
              <span className={`w-6 font-serif text-xl ${MEDAL[i] || "text-[#8C8498]"}`}>{i + 1}</span>
              <span className="flex-1 min-w-0"><span className="block truncate font-medium">{r.name}</span><span className="block truncate text-xs text-[#8C8498]">{r.contact}{r.code && <> · <span className="font-mono">{r.code}</span></>}</span></span>
              <span className="text-right"><span className="block font-semibold" data-testid={`leaderboard-friends-${i + 1}`}>{r.friends} friend{r.friends === 1 ? "" : "s"}</span><span className="block text-xs text-[#8C8498]">earned {inr(r.earned)} · {inr(r.credit)} unspent</span></span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
